export default __webpack_public_path__ + "img/bg-nmo.c50400f5.svg";